import axios from 'api/axios'
import { useCallback, useEffect, useState } from 'react'

// /**
//  * @module FetchHooks
//  */
// /**
//  * @module EfacturasVentas
//  */

/**
 *
 * @param {Object} prop
 * @param {Object} props.filters
 */

const useFetchEfacturasVentas = ({ reFetch = 0 }) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(() => {
    setLoading(true)
    axios
      .get(`/efactura/ventas/?idioma=01`)
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }, [])

  useEffect(() => {
    if (!loading) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reFetch])

  return { response, error, loading }
}

export default useFetchEfacturasVentas
